/**
 * Fila do DPO (Onda 7.6 / A13). Espelha `entity/EstadoIncidente`,
 * `dto/IncidenteEventoResponse` e `dto/ResumoIncidentesResponse` do originei-auth.
 */

/** Máquina de estados da fila — só anda para frente; ENCERRADO é terminal. */
export type EstadoIncidente =
  | 'REPORTADO'
  | 'TRIAGEM'
  | 'CONTENCAO'
  | 'INVESTIGACAO'
  | 'RESOLVIDO'
  | 'ENCERRADO'

export const ESTADOS_INCIDENTE: EstadoIncidente[] = [
  'REPORTADO', 'TRIAGEM', 'CONTENCAO', 'INVESTIGACAO', 'RESOLVIDO', 'ENCERRADO',
]

export const ESTADO_INCIDENTE_LABEL: Record<EstadoIncidente, string> = {
  REPORTADO: 'Reportado',
  TRIAGEM: 'Triagem',
  CONTENCAO: 'Contenção',
  INVESTIGACAO: 'Investigação',
  RESOLVIDO: 'Resolvido',
  ENCERRADO: 'Encerrado',
}

/** Lista curta do formulário do consultor — `categoria` é texto no servidor (max 40). */
export const CATEGORIAS_INCIDENTE: { value: string; label: string }[] = [
  { value: 'VAZAMENTO', label: 'Vazamento de dados' },
  { value: 'ACESSO_INDEVIDO', label: 'Acesso indevido' },
  { value: 'PERDA_DISPOSITIVO', label: 'Perda ou roubo de dispositivo' },
  { value: 'ENVIO_INDEVIDO', label: 'Envio a destinatário errado' },
  { value: 'MALWARE', label: 'Malware / ransomware' },
  { value: 'OUTRO', label: 'Outro' },
]

export interface IncidenteEvento {
  id: string
  de: EstadoIncidente | null
  para: EstadoIncidente
  autor: string
  em: string
  nota?: string | null
}

export interface ResumoIncidentes {
  abertos: number
  emTratamento: number
  criticos: number
  encerradosNoMes: number
}

export interface TransicaoIncidenteRequest {
  para: EstadoIncidente
  nota?: string
}
